import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { BookOpen, List } from "lucide-react";
import {
  SidebarToggle,
  useAdminLayout,
} from "../../components/admin/AdminLayout";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { isMobile } = useAdminLayout();

  return (
    <div className="w-full">
      <div className="flex items-center mb-6">
        {isMobile && <SidebarToggle className="mx-2" />}
        <h1 className="text-xl md:text-2xl font-semibold">Bảng điều khiển</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-lg">Bài viết</CardTitle>
            <CardDescription>Quản lý bài viết</CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full"
              onClick={() => navigate("/admin/articles")}
            >
              <BookOpen className="h-4 w-4 mr-2" />
              Quản lý bài viết
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-lg">Danh mục</CardTitle>
            <CardDescription>Quản lý danh mục và danh mục con</CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full"
              onClick={() => navigate("/admin/categories")}
            >
              <List className="h-4 w-4 mr-2" />
              Quản lý danh mục
            </Button>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Thống kê</CardTitle>
          <CardDescription>Tổng quan về dữ liệu website</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-gray-500">
            Chức năng thống kê sẽ được cập nhật trong thời gian tới.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminDashboard;
